import { render, staticRenderFns } from "./uppackage.vue?vue&type=template&id=62608d4a&scoped=true"
import script from "./uppackage.vue?vue&type=script&lang=js"
export * from "./uppackage.vue?vue&type=script&lang=js"
import style0 from "./uppackage.vue?vue&type=style&index=0&id=62608d4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62608d4a",
  null
  
)

export default component.exports